import { StoreWarningMessage, StoreWarningMessageIcon } from './StoreWarningBanner.parts';

export type StoreWarningBannerProps = {
	warningMessage?: string | null;
};

export function StoreWarningBanner(props: StoreWarningBannerProps) {
	return (
		<StoreWarningMessage visible={!!props.warningMessage}>
			<StoreWarningMessageIcon />
			{props.warningMessage || ''}
		</StoreWarningMessage>
	);
}
